export interface Category {
  id: string;
  nameKey: string;
  url: string;
  image: string;
}

export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const categories: Category[] = [
  {
    id: "shoes",
    nameKey: "category.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20premium%20white%20leather%20sneakers%20displayed%20on%20a%20light%20grey%20concrete%20ledge%20with%20soft%20natural%20daylight%20from%20a%20large%20window%20minimal%20studio%20setting%20clean%20product%20photography%20sharp%20focus%20subtle%20shadow%20fresh%20modern%20aesthetic%20high%20detail&width=600&height=600&seq=cat-shoes-v2&orientation=squarish",
  },
  {
    id: "hoodies",
    nameKey: "category.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20pastel%20mint%20green%20hoodie%20casually%20draped%20over%20a%20natural%20oak%20wood%20chair%20in%20a%20bright%20Scandinavian%20room%20soft%20morning%20light%20lifestyle%20product%20photography%20warm%20neutral%20tones%20cozy%20atmosphere%20high%20detail&width=600&height=600&seq=cat-hoodies-v2&orientation=squarish",
  },
  {
    id: "tshirts",
    nameKey: "category.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20stack%20of%20folded%20organic%20cotton%20t-shirts%20in%20cream%20beige%20and%20soft%20grey%20tones%20arranged%20on%20a%20white%20marble%20countertop%20top-down%20flat%20lay%20soft%20diffused%20studio%20light%20minimalist%20editorial%20style%20high%20detail&width=600&height=600&seq=cat-tshirts-v2&orientation=squarish",
  },
  {
    id: "jackets",
    nameKey: "category.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20tan%20suede%20bomber%20jacket%20hanging%20on%20a%20minimalist%20brass%20coat%20rack%20against%20a%20warm%20sand-colored%20wall%20soft%20ambient%20lighting%20editorial%20fashion%20photography%20clean%20lines%20premium%20streetwear%20mood%20high%20detail&width=600&height=600&seq=cat-jackets-v2&orientation=squarish",
  },
  {
    id: "pants",
    nameKey: "category.pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20charcoal%20grey%20tailored%20trousers%20neatly%20folded%20on%20a%20light%20linen%20fabric%20surface%20overhead%20shot%20soft%20natural%20daylight%20clean%20minimalist%20product%20photography%20subtle%20texture%20contrast%20high%20detail&width=600&height=600&seq=cat-pants-v2&orientation=squarish",
  },
  {
    id: "headwear",
    nameKey: "category.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Three%20premium%20baseball%20caps%20in%20neutral%20beige%20olive%20and%20cream%20colors%20arranged%20in%20a%20neat%20row%20on%20a%20pale%20wooden%20table%20top%20soft%20side%20lighting%20lifestyle%20product%20photography%20warm%20earthy%20tones%20high%20detail&width=600&height=600&seq=cat-headwear-v2&orientation=squarish",
  },
  {
    id: "sets",
    nameKey: "category.sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20coordinated%20tracksuit%20set%20in%20soft%20sage%20green%20laid%20flat%20on%20a%20white%20cotton%20sheet%20bed%20overhead%20flat%20lay%20natural%20window%20light%20cozy%20athletic%20lifestyle%20photography%20clean%20and%20airy%20mood%20high%20detail&width=600&height=600&seq=cat-sets-v2&orientation=squarish",
  },
  {
    id: "underwear",
    nameKey: "category.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20set%20of%20soft%20cotton%20boxer%20briefs%20in%20white%20and%20heather%20grey%20displayed%20on%20a%20light%20bamboo%20tray%20spa-like%20clean%20setting%20soft%20warm%20lighting%20intimate%20apparel%20product%20photography%20high%20detail&width=600&height=600&seq=cat-underwear-v2&orientation=squarish",
  },
  {
    id: "jersey",
    nameKey: "category.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20classic%20basketball%20jersey%20in%20deep%20navy%20and%20cream%20stripes%20laid%20flat%20on%20a%20vintage%20basketball%20court%20floor%20with%20soft%20overhead%20gym%20lighting%20sporty%20editorial%20photography%20nostalgic%20mood%20high%20detail&width=600&height=600&seq=cat-jersey-v2&orientation=squarish",
  },
  {
    id: "accessories",
    nameKey: "category.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20minimalist%20accessories%20including%20a%20leather%20watch%20strap%20silver%20ring%20and%20thin%20chain%20bracelet%20arranged%20on%20a%20dark%20slate%20surface%20dramatic%20side%20lighting%20luxury%20product%20photography%20high%20detail&width=600&height=600&seq=cat-accessories-v2&orientation=squarish",
  },
  {
    id: "bags",
    nameKey: "category.bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20structured%20canvas%20tote%20bag%20in%20natural%20beige%20with%20leather%20handles%20placed%20beside%20a%20small%20potted%20plant%20on%20a%20light%20oak%20shelf%20lifestyle%20interior%20photography%20soft%20daylight%20warm%20organic%20aesthetic%20high%20detail&width=600&height=600&seq=cat-bags-v2&orientation=squarish",
  },
  {
    id: "belts",
    nameKey: "category.belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20hand-stitched%20dark%20brown%20leather%20belt%20coiled%20elegantly%20on%20a%20textured%20cork%20mat%20with%20a%20small%20brass%20buckle%20catching%20soft%20warm%20light%20artisan%20product%20photography%20earthy%20tones%20high%20detail&width=600&height=600&seq=cat-belts-v2&orientation=squarish",
  },
  {
    id: "perfumes",
    nameKey: "category.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20collection%20of%20elegant%20minimalist%20perfume%20bottles%20in%20amber%20and%20clear%20glass%20displayed%20on%20a%20mirrored%20vanity%20tray%20with%20soft%20bokeh%20background%20lighting%20luxury%20beauty%20product%20photography%20glamorous%20mood%20high%20detail&width=600&height=600&seq=cat-perfumes-v2&orientation=squarish",
  },
  {
    id: "other",
    nameKey: "category.other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=An%20assorted%20flat%20lay%20of%20premium%20lifestyle%20items%20including%20sunglasses%20a%20portable%20speaker%20a%20notebook%20and%20a%20water%20bottle%20on%20a%20light%20concrete%20surface%20overhead%20shot%20soft%20diffused%20light%20modern%20product%20photography%20high%20detail&width=600&height=600&seq=cat-other-v2&orientation=squarish",
  },
];